<template>
  <v-container fluid class="px-lg-5">
    <app-header :title="title" :breadcrumbs="visibleBreadcrumbs" disable-button />
    <div class="row">
      <div class="col-12">
        <v-card class="rounded-card" flat outlined>
          <v-card-text class="mt-5 mb-3 px-12">
            <app-form
              ref="form"
              :fields="fields"
              :submitButton="submitButton"
              @selection-changed="onOfficeSelectionChange"
              @submitted="handleSubmit"
              disableCancelButton
            />
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'AttendanceForm',
  data() {
    return {
      title: {
        text: this.$t('layout.mainMenu.attendance'),
        icon: 'mdi-fingerprint'
      },
      fields: {
        selectedOffice: {
          type: 'select',
          key: 'officeId',
          value: null,
          options: [],
          label: this.$t('models.company.attributes.office'),
          rules: [{name: 'requiredSelect'}],
          trackable: true,
          itemText: 'name',
          itemValue: 'id',
          classes: 'col-lg-6 col-md-12 py-0',
          serverErrors: []
        },
        excludedUsers: {
          type: 'select',
          multiple: true,
          key: 'userIds',
          value: [],
          options: [],
          label: this.$t('models.company.attributes.excludedUsers'),
          chips: true,
          clearable: true,
          itemText: 'name',
          itemValue: 'id',
          classes: 'col-lg-6 col-md-12 py-0',
          serverErrors: []
        },
        attachment: {
          type: 'file',
          key: 'attachment',
          showImage: true,
          value: null,
          outlined: true,
          dense: true,
          clearable: true,
          showSize: true,
          accept: '.xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv',
          icon: 'mdi-file-document',
          label: this.$t('models.company.attributes.file'),
          rules: [{name: 'required'}],
          classes: 'col-12 py-0',
          serverErrors: []
        }
      },
      submitButton: {
        label: this.$t('actions.submit')
      }
    };
  },
  computed: {
    ...mapGetters(['users', 'isAdmin', 'offices', 'attendance']),
    visibleBreadcrumbs() {
      return [
        {
          text: this.$t('layout.mainMenu.home'),
          to: {name: 'Home'}
        },
        {
          text: this.$t('layout.mainMenu.attendance'),
          to: {name: 'AttendanceForm'}
        }
      ];
    }
  },
  methods: {
    ...mapActions(['getUsers', 'getOffices', 'fetchAttendanceSummary']),
    handleSubmit(data) {
      const transformedData = {
        office_id: parseInt(data.office_id),
        file: data.attachment[0],
        excluded_users: (data.user_ids || []).map((id) => parseInt(id))
      };
      this.fetchAttendanceSummary(transformedData);
    },
    onOfficeSelectionChange(fieldData) {
      if (fieldData.key === 'officeId') {
        this.fields.excludedUsers.value = [];
        this.loadUsersForOffice(fieldData.value);
      }
    },
    loadUsersForOffice(officeId) {
      if (!officeId) {
        this.fields.excludedUsers.options = [];
        return;
      }

      this.getUsers()
        .then(() => {
          const usersInOffice = this.users.items
            .filter((user) => user.office.id === parseInt(officeId))
            .map((user) => ({id: user.id, name: user.name}));

          this.fields.excludedUsers.options = usersInOffice;
        });
    }
  },
  created() {
    this.getOffices().then(() => {
      this.fields.selectedOffice.options = this.offices.items;
    });
  }
};
</script>
